import { useAuthQuery } from 'features/common/apiUtils/queryHelper';
import { auditLogsApi } from '../api/endpoints';
import { AuditLogsResponse } from '../types';
import { AuditLogsSupportedSystemName } from '../constants';
import { AxiosResponse } from 'axios';

export const useGetLogs = ({
  onSuccess,
  onError,
  system,
  continuationToken,
  query,
}: {
  onSuccess: (data: AxiosResponse<AuditLogsResponse>) => void;
  onError: () => void;
  system: AuditLogsSupportedSystemName;
  continuationToken: string;
  query?: string;
}) => {
  const { get_logs } = auditLogsApi;
  const url = get_logs.url({
    system,
    continuationToken,
    query,
  });

  return useAuthQuery(
    [url],
    async (axiosInstance) => {
      return axiosInstance?.get<AuditLogsResponse>(url);
    },
    { onSuccess, onError },
    get_logs.scope,
  );
};
